<template>
  <div class="clavier-action">
    <v-container
      fluid
      class="pa-1"
    >
      <v-row>
        <v-col
          cols="12"
          md="6"
          offset-md="3"
          lg="4"
          offset-lg="4"
          class="d-flex"
          :class="{ 'pb-2': !IS_IOS }"
        >
          <div
            v-show="btnCancel || btnCancelDisabled"
            :class="btnCancelDisabled ? 'disabled' : 'rouge'"
            class="touche"
            name="bottom-cancel"
            @click="btnCancelDisabled ? null : $emit('cancel')"
          >
            <img
              :src="AppImages.pictoCroix"
              alt="cross"
              width="22"
            >
          </div>
          <div
            v-show="btnDel || btnDelDisabled"
            :class="btnDelDisabled ? 'disabled' : 'jaune'"
            class="touche"
            name="bottom-back"
            @click="btnDelDisabled ? null : $emit('del')"
          >
            <img
              :src="AppImages.pictoInferieur"
              alt="min"
              width="22"
            >
          </div>
          <div
            v-show="btnValid || btnValidDisabled || keyboardValid"
            :class="btnValidDisabled ? 'disabled' : (btnValid ? 'vert' : '')"
            :name="keyboardValid ? 'bottom-keyboard' : 'bottom-valid'"
            class="touche"
            @click="btnValidDisabled ? null : $emit('valid')"
          >
            <v-icon
              v-if="keyboardValid"
              large
            >
              {{ IconEnum.keyboard }}
            </v-icon>
            <img
              v-else
              :src="AppImages.pictoRond"
              alt="valid"
              width="22"
            >
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { IconEnum } from '@/modules/Enums'
import { AppImages } from '@/modules/Images'

export default {
  name: 'BottomAction',

  props: {
    btnDel: { type: Boolean, default: true },
    btnDelDisabled: { type: Boolean, default: false },
    btnCancel: { type: Boolean, default: false },
    btnCancelDisabled: { type: Boolean, default: false },
    btnValid: { type: Boolean, default: false },
    btnValidDisabled: { type: Boolean, default: false },
    keyboardValid: { type: Boolean, default: false },
    useListener: { type: Boolean, default: true }
  },

  data () {
    return {
      IconEnum,
      AppImages,
      IS_IOS
    }
  },

  watch: {
    useListener (newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        this.startListener()
      } else {
        this.stopListener()
      }
    }
  },

  mounted () {
    if (this.useListener) this.startListener()
  },

  beforeDestroy () {
    if (this.useListener) this.stopListener()
  },

  methods: {
    startListener () {
      window.addEventListener('keyup', this.keyup, false)
    },
    stopListener () {
      window.removeEventListener('keyup', this.keyup, false)
    },
    keyup (e) {
      switch (e.key) {
        case 'Enter':
          this.$emit('valid')
          break
        // case 'Backspace':
        //   this.$emit('del')
        //   break
        case 'Escape':
          this.$emit('cancel')
          break
        default:
          break
      }
    }
  }
}
</script>

<style scoped>
.clavier-action {
  background-image: linear-gradient(33deg, #444346, #90898e);
}

.touche:active,
.touche {
  height: 54px;
  max-width: 54px;
  margin: auto;
}
</style>
